// "Підключити Claude" and the Entitlements behind "Мій сайт", the same rules the mobile app follows
// (apps/app/lib/siteAssistant.ts).

interface EntitlementLike {
  key: string;
  booleanValue?: boolean | null;
}

function hasBooleanEntitlement(entitlements: EntitlementLike[] | null | undefined, key: string) {
  return entitlements?.find((entitlement) => entitlement.key === key)?.booleanValue === true;
}

// "Мій сайт" shows only where the Account's plan (or its own override) includes a site.
export function hasProviderSite(entitlements: EntitlementLike[] | null | undefined) {
  return hasBooleanEntitlement(entitlements, "provider_site");
}

// The AI designer chat is its own Entitlement (`ai_designer`); without it the Provider creates and
// changes their site with their own Claude.
export function hasAiDesigner(entitlements: EntitlementLike[] | null | undefined) {
  return hasBooleanEntitlement(entitlements, "ai_designer");
}

// The Provider's own Claude or ChatGPT on their site (`provider_site_own_assistant`): Pro.
export function hasOwnAssistant(entitlements: EntitlementLike[] | null | undefined) {
  return hasBooleanEntitlement(entitlements, "provider_site_own_assistant");
}

// A request still waiting for an answer, which the admin shows once even without its push.
export function isRequestWaiting(
  request: { uuid: string; status: string; expiresAt: string } | null | undefined,
  now: number = Date.now()
) {
  return Boolean(
    request && request.status === "PENDING" && new Date(request.expiresAt).getTime() > now
  );
}

export const assistantName = (clientName: string | null | undefined) =>
  clientName?.trim() || "Claude";

// Claude with a ready request in its message box; the Provider sends it themselves.
export function claudePromptUrl(prompt: string) {
  return `https://claude.ai/new?q=${encodeURIComponent(prompt)}`;
}
